import { createUseStyles } from 'react-jss'
import { commonStyles } from '../../shared/common.styles'

export const useStyles = createUseStyles(theme => ({
  ...commonStyles(theme),
  title: {
    fontSize: 40,
    fontFamily: 'GothamRounded',
    lineHeight: 1,
    fontWeight: 450,
    letterSpacing: 'normal',
    textAlign: 'center',
    margin: [20, 0],
    [theme.media.smallMobile]: {
      margin: [10, 20],
      fontSize: 32
    }
  },

  subTitle: {
    fontSize: 18,
    fontFamily: 'GTWalsheim',
    lineHeight: 1,
    fontWeight: 500,
    letterSpacing: 'normal',
    textAlign: 'center',
    marginTop: 0,
    [theme.media.smallMobile]: {
      fontSize: 16,
      margin: [0, 20],
      lineHeight: '18px'
    }
  },

  content: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 20,
    paddingBottom: 200,
    [theme.media.smallMobile]: {
      paddingTop: 15,
      paddingBottom: 100
    }
  },

  profileList: {
    maxWidth: 770,
    maxHeight: 'max-content',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexFlow: 'row wrap'
  },

  buttonWrapper: {
    display: 'flex',
    padding: [0, 20],
    [theme.media.smallMobile]: {
      width: '100%'
    }
  },

  button: {
    minWidth: 437,
    marginTop: 35,
    [theme.media.smallMobile]: {
      marginTop: 30,
      minWidth: 240
    }
  },

  avatar: {
    width: 110,
    height: 110,
    [theme.media.smallMobile]: {
      width: 80,
      height: 80
    }
  },

  itemOverlay: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 120,
    height: 120,
    [theme.media.smallMobile]: {
      width: 90,
      height: 90,
      marginLeft: 5,
      marginRight: 5
    },
    borderRadius: '50%',
    transition: 'background 300ms ease-in',
    '&:hover': {
      background: theme.neonPrimary
    },
    marginLeft: 10,
    marginRight: 10,
    cursor: 'pointer'
  },

  selected: {
    background: theme.neonPrimary
  },

  errorMessage: {
    fontSize: 14,
    fontFamily: 'GTWalsheim',
    lineHeight: 1,
    fontWeight: 500,
    color: '#e73339',
    paddingTop: 20,
    height: 10,
    [theme.media.smallMobile]: {
      paddingTop: 10
    }
  }
}))
